import { lazy } from 'react'

// -------

import { routes } from 'config/app'
import { Rules } from 'config/permissions'

// Categories
const CategoriesListPage = lazy(() => import('./Categories/List'))
const CategoriesFormPage = lazy(() => import('./Categories/Form'))

// Types
const TypesListPage = lazy(() => import('./Types/List'))
const TypesFormPage = lazy(() => import('./Types/Form'))

// Products
const ProductsListPage = lazy(() => import('./Products/List'))
const ProductsFormPage = lazy(() => import('./Products/Form'))
const ProductsDetailsPage = lazy(() => import('./Products/Details'))

// -------

const route = routes.baseAdminRoute + '/inventory'

// -------

export const Api = {
  // Categories
  categories: '/inventory/categories',
  category: '/inventory/categories/:id',
  categoriesActive: '/inventory/categories/active',
  categoriesExport: '/inventory/categories/export',
  categoriesBulkDelete: '/inventory/categories/bulk-delete',
  categoryToggleStatus: '/inventory/categories/:id/toggle-status',

  // Types
  types: '/inventory/types',
  type: '/inventory/types/:id',
  typesActive: '/inventory/types/active',
  typesExport: '/inventory/types/export',
  typesStatistics: '/inventory/types/statistics',
  typesBulkDelete: '/inventory/types/bulk-delete',
  typeToggleStatus: '/inventory/types/:id/toggle-status',

  // Products
  products: '/inventory/products',
  product: '/inventory/products/:id',
  productsFormFilters: '/inventory/products/form-filters',
  productsLowStock: '/inventory/products/low-stock',
  productUpdateQuantity: '/inventory/products/:id/quantity',
  productDetails: '/inventory/products/:id/details',
  productComplete: '/inventory/products/:id/complete',
}

export const Routes = {
  // Categories
  categories: `${route}/categories`,
  categoriesForm: `${route}/categories/:id/form`,

  // Types
  types: `${route}/types`,
  typesForm: `${route}/types/:id/form`,

  // Products
  products: `${route}/products`,
  productsForm: `${route}/products/:id/form`,
  productsDetails: `${route}/products/:id/details`,

  // Legacy support (redirect to products)
  index: `${route}/products`,
  form: `${route}/products/:id/form`
}

// COMPONENTS
export const Components = [
  // Categories
  { path: Routes.categories, component: CategoriesListPage, permission: Rules.page.inventory.categories },
  { path: Routes.categoriesForm, component: CategoriesFormPage, permission: Rules.page.inventory.categories },

  // Types
  { path: Routes.types, component: TypesListPage, permission: Rules.page.inventory.types },
  { path: Routes.typesForm, component: TypesFormPage, permission: Rules.page.inventory.types },

  // Products
  { path: Routes.products, component: ProductsListPage, permission: Rules.page.inventory.products },
  { path: Routes.productsForm, component: ProductsFormPage, permission: Rules.page.inventory.products },
  { path: Routes.productsDetails, component: ProductsDetailsPage, permission: Rules.page.inventory.products },

  // Legacy support
  { path: Routes.index, component: ProductsListPage, permission: Rules.page.inventory.products },
  { path: Routes.form, component: ProductsFormPage, permission: Rules.page.inventory.products }
]
